export const PHASES = {
  START: 'START',
  UPLOADING: 'UPLOADING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
} as const

export type PHASES = (typeof PHASES)[keyof typeof PHASES]
interface State {
  fileName: string
  currentPhase: PHASES
  errors: Record<string, string>[]
  invalidFileName: boolean
}

export const ActionType = {
  reset: 'reset',
  setInvalidName: 'setInvalidName',
  setFilename: 'setFilename',
  setCurrentPhase: 'setCurrentPhase',
  setErrors: 'setErrors',
} as const

export type ActionType = (typeof ActionType)[keyof typeof ActionType]

type Action =
  | { type: typeof ActionType.reset }
  | { type: typeof ActionType.setInvalidName; payload: boolean }
  | { type: typeof ActionType.setFilename; payload: string }
  | { type: typeof ActionType.setCurrentPhase; payload: PHASES }
  | { type: typeof ActionType.setErrors; payload: Record<string, string>[] }

export const initialState = {
  fileName: '',
  currentPhase: PHASES.START,
  errors: [],
  invalidFileName: false,
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'reset': {
      return {
        ...state,
        ...initialState,
      }
    }
    case 'setInvalidName': {
      return {
        ...state,
        ...initialState,
        invalidFileName: action.payload,
      }
    }
    case 'setFilename': {
      return {
        ...state,
        invalidFileName: false,
        fileName: action.payload,
      }
    }
    case 'setCurrentPhase': {
      return {
        ...state,
        currentPhase: action.payload,
      }
    }
    case 'setErrors': {
      return {
        ...state,
        currentPhase: PHASES.ERROR,
        errors: action.payload,
      }
    }
    default:
      throw Error(`The action.type does not exist in the reducer.`, { cause: action })
  }
}
